import { VISITOR } from 'app/routes'
import { ExclamationTriangleIcon } from 'assets/icons'
import { ButtonLoading } from 'components/Buttons'
import { Modal, ModalContent, ModalIcon } from 'components/Modal'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActiveTickets } from 'store/useActiveTickets'
import { usePlace } from 'store/usePlace'
import { useWizardForm } from 'store/useWizardForm'
import FormattedMessage from 'utils/FormattedMessage'
import { useTranslation } from 'utils/useTranslation'
import { CATEGORY_STEP, SERVICE_STEP, useWizardSteps } from '../useWizardSteps'

export const TicketSettingModal = () => {
  const intl = useTranslation()
  const navigate = useNavigate()
  const { tickets, isLoadingServices } = useActiveTickets()
  const { place } = usePlace()
  const [show, setShow] = useState(false)
  const selectedServiceId = useWizardForm(s => s.wizardForm.serviceId)

  const { activeStep } = useWizardSteps()

  const isServiceStep = activeStep === SERVICE_STEP || activeStep === CATEGORY_STEP
  const appointmentsPerUser = place?.settings?.appointmentsPerUser

  const oneTicketPerPlace =
    appointmentsPerUser === 'one-per-place' && tickets.length > 0 && isServiceStep

  const ticketForSelectedService = selectedServiceId
    ? tickets.find(t => t.serviceId === selectedServiceId)
    : undefined

  const oneTicketPerService =
    appointmentsPerUser === 'one-per-service' && !!ticketForSelectedService && isServiceStep

  const unlimitedTickets =
    appointmentsPerUser === 'unlimited' && tickets.length > 0 && isServiceStep

  useEffect(() => {
    setShow(!isLoadingServices && (oneTicketPerPlace || oneTicketPerService || unlimitedTickets))
  }, [isLoadingServices, oneTicketPerPlace, oneTicketPerService, unlimitedTickets])

  const targetTicket = oneTicketPerService ? ticketForSelectedService : tickets[0]

  const goToTicket = () => {
    if (targetTicket) {
      navigate(VISITOR.TICKET.replace(':placeId', place?.id || '').replace(':id', targetTicket.id))
    }
  }

  return (
    <Modal
      open={show}
      closeIcon={false}
      submitButton={
        <ButtonLoading onClick={goToTicket} style={'btn-primary'}>
          <FormattedMessage id='ticketSettingModal.submit' />
        </ButtonLoading>
      }
      cancelButton={
        unlimitedTickets ? (
          <ButtonLoading
            onClick={() => {
              setShow(false)
            }}
            style='btn-secondary'
          >
            <FormattedMessage id='ticketSettingModal.unlimited.cancel' />
          </ButtonLoading>
        ) : undefined
      }
    >
      <ModalIcon
        icon={<ExclamationTriangleIcon className='h-6 w-6  stroke-orange-600' aria-hidden='true' />}
      />
      {oneTicketPerPlace && (
        <ModalContent
          title={intl({ id: 'ticketSettingModal.title' })}
          description={intl({ id: 'ticketSettingModal.onePerPlace.description' })}
        />
      )}
      {oneTicketPerService && (
        <ModalContent
          title={intl({ id: 'ticketSettingModal.title' })}
          description={intl({ id: 'ticketSettingModal.onePerService.description' })}
        />
      )}
      {unlimitedTickets && (
        <ModalContent
          title={intl({ id: 'ticketSettingModal.title' })}
          description={intl({ id: 'ticketSettingModal.unlimited.description' })}
        />
      )}
    </Modal>
  )
}
